<template>
  <div
    class="app-toggler-control"
    :class="{ 'app-toggler-control--checked': innerValue }"
  >
    <label class="app-toggler-control__main">
      <app-title-box
        v-if="title"
        class="app-toggler-control__title"
        size="small"
        :title="title"
        :isTooltip="!!tooltip"
        :tooltip="tooltip"
        :isRequired="isRequired"
      ></app-title-box>
      <div class="app-toggler-control__toggle-wrap">
        <input
          class="app-toggler-control__input"
          type="checkbox"
          @focus="handleFocus"
          @blur="handleBlur"
          @change="handleChange"
          v-bind="$attrs"
          :disabled="isDisabled"
          :readonly="isReadonly"
        />
        <div class="app-toggler-control__toggle"></div>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'AppTogglerControl',
  components: {
    AppTitleBox: () => import('@/components/common/AppTitleBox'),
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    isRequired: {
      type: Boolean,
    },
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
    },
    tooltip: {
      type: String,
      default: '',
    },
    isDisabled: {
      type: Boolean,
    },
    isReadonly: {
      type: Boolean,
    },
  },
  data: (vm) => ({
    innerValue: vm.value,
  }),
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.innerValue = value;
      },
    },
  },
  methods: {
    /**
     * Действие на событие change
     * @param event
     */
    handleChange() {
      if (!this.isDisabled) {
        this.innerValue = !this.innerValue;
        this.$emit('input', this.innerValue);
      }
    },
    /**
     * Действие на событие blur
     * @param event
     */
    handleBlur(event) {
      this.$emit('blur', event);
    },
    /**
     * Действие на событие focus
     * @param event
     */
    handleFocus(event) {
      this.$emit('focus', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-toggler-control {
  $root: &;

  position: relative;
  width: 100%;

  &__main {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 7px 12px;
    cursor: pointer;
    background: $white;
    border: 1px solid $gray-light;
    border-radius: 2px;
    transition: border $A;

    &:hover {
      border-color: $color-brand-green;
    }
  }

  &__title {
    margin-bottom: 8px;
  }

  &__toggle-wrap {
    // -
  }

  &__toggle {
    position: relative;
    height: 20px;

    &::before {
      position: relative;
      display: inline-block;
      width: 38px;
      height: 20px;
      content: '';
      background: #ececec;
      border-radius: 100px;
    }

    &::after {
      position: absolute;
      top: 1px;
      left: 1px;
      display: inline-block;
      width: 18px;
      height: 18px;
      content: '';
      background: #fff;
      border-radius: 100px;
      transition: all 0.15s linear;
    }
  }

  &__input {
    display: none;
  }

  &--checked {
    #{$root}__toggle {
      &::before {
        content: '';
        background: #02b55f;
      }

      &::after {
        left: 19px;
        content: '';
      }
    }
  }
}
</style>
